import { connect } from 'react-redux'
import { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { useQuery } from 'Hooks'
import { Button, Row, Col } from 'antd'
import GraphFilterButton from '../GraphFilterButton'
import SearchGraphButton from '../SearchGraphButton'
import ColorService from 'Services/ColorService'
import { loadGraphDataFromNodes } from 'Services/GraphUtils'
import { getTypeNodeForNode } from 'Services/WeaverUtils'
import HeadsUpDisplay from './HeadsUpDisplay'
import ForceGraphVR from '3d-force-graph-vr'
import ForceGraph3D from '3d-force-graph'
import { setFilteredNodesBySearch } from 'Actions/graphFilter'
import './index.scss'
import Feather from '@sysunite/react-feather'

import {
  setCurrentItem,
  setTab
} from 'Actions/explore'

getNodeColor = ({ id }) ->
  ColorService.getColorForType(id)

WeWeVr = ({ data, setFilteredNodesBySearch, filteredNodes, goToTwoDMode, setCurrentItem, setTab, tabIsLocked, darkModeEnabled }) ->

  params = useQuery()
  history = useHistory()
  { url } = useRouteMatch()
  { hash }  = useLocation()

  [nodes, setNodes] = useState([])
  [graphData, setGraphData] = useState(undefined)
  [vrAvailable, setVrAvailable] = useState(undefined)
  [active, setActive] = useState(undefined)
  [filters, setFilters] = useState({})

  Graph = useRef(undefined)

  setDetailData = (node) ->
    setCurrentItem({
      type: 'ATTRIBUTES',
      id: node.id
    })
    params.set('tab', 'attributes')
    history.replace({ pathname: url, search: params.toString(), hash })
    setTab('attributes') unless tabIsLocked

  useEffect( ->
    ( ->
      xr = navigator.xr
      isSupported = await xr.isSessionSupported("immersive-vr")
      setVrAvailable(isSupported)
    )()
    undefined
  , [])

  showAndHideQueryConsole = (display) ->
    document.getElementsByClassName('graph-console-container')[0]?.style.display = (
      if display then 'block' else 'none'
    )

  useEffect( ->
    return unless data? and vrAvailable?
    ( ->
      nodes = _.values(data.nodes).map(({ id, label, group }) ->
        { id, label, group }
      )
      links = _.values(data.edges).map((edge) ->
        { source: edge.from, target: edge.to, label: edge.label }
      )
      if vrAvailable
        showAndHideQueryConsole(false)
        Graph.current = ForceGraphVR()(document.getElementById('threeD-graph'))
      else
        Graph.current = ForceGraph3D()(document.getElementById('threeD-graph'))

      Graph.current
        .graphData({ nodes, links })
        .nodeResolution(20)
        .linkLabel('label')
        .linkWidth(1)
        .linkAutoColorBy('source')
        .linkOpacity(0.1)
        .nodeLabel('label')
        .nodeOpacity(1)
        .linkDirectionalArrowLength(5)

      if not vrAvailable
        Graph.current
          .onNodeHover(setActive)
          .backgroundColor(darkModeEnabled && '#082533' || '#fff')
          .nodeColor(getNodeColor)
          .onNodeClick(setDetailData)
      else
        Graph.current
          .onNodeCenterHover(setActive)
          .nodeAutoColorBy('group')
    )()
    undefined
  , [data, vrAvailable])

  useEffect( ->
    toFilter = _.uniq(
      _.values(filteredNodes).reduce((acc, curr) ->
        acc.concat(curr)
      , [])
    )
    return unless toFilter.length > 0

    if Graph?.current?
      Graph.current
        .nodeVisibility((node) -> toFilter.indexOf(node.id) is -1 )
        .linkVisibility((link) => (toFilter.indexOf(link.source.id) is -1) and (toFilter.indexOf(link.target.id) is -1))

    undefined
  , [filteredNodes])

  onChangeFilter = (key, val) =>
    setFilters({ filters..., [key]: val })

  onSearchGraph = (value) =>
    { nodes } = data

    if value is '' then return setFilteredNodesBySearch([])

    result = _.filter(nodes, (node) ->
      !(
        node.label.toLowerCase().includes(value.toLowerCase()) or
        node.id.toLowerCase().includes(value.toLowerCase())
      )
    ).map((node) -> node.id)

    setFilteredNodesBySearch(result)

  <div style={{ position: 'relative' }}>
    {if vrAvailable
      <HeadsUpDisplay node={active} />
    }
    <Row align="top" gutter={26} style={{ pointerEvents: 'none', margin: '16px', zIndex: 2, position: 'absolute' }}>
      {if not vrAvailable
        <Col style={{ pointerEvents: 'auto' }}>
          <SearchGraphButton onSearch={onSearchGraph}/>
        </Col>
      }
      <Col style={{ pointerEvents: 'auto' }}>
        <Button
          onClick={ ->
            showAndHideQueryConsole(true)
            goToTwoDMode()
          }
          icon={<Feather size="1.2em" type="codepen" style={{ color: 'white' }} />}
          shape="circle"
          style={{ border: 'none', background: '#58bd91', padding: 5 }}
        />
      </Col>
    </Row>
    <div id="threeD-graph" style={{ width: '100%', height: '100vh' }} />
  </div>

mapStateToProps = ({
  explore: { darkModeEnabled, tabIsLocked }
  graph,
  graphFilter: {
    filteredNodes
    graphFilters
    labelFilters
    relationFilters
    typeFilters
  }
}) ->
  {
    darkModeEnabled
    tabIsLocked
    data: graph.graphData
    filteredNodes
    graphFilters
    labelFilters
    relationFilters
    typeFilters
  }

export default connect(mapStateToProps, { setFilteredNodesBySearch, setCurrentItem, setTab })(WeWeVr)
